<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="c-roodie"
    ref="roodie"
  >
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24H0V12Z"
      :fill="fillOuter"
    />
    <path
      d="M8.25 9C9.07843 9 9.75 8.32843 9.75 7.5C9.75 6.67157 9.07843 6 8.25 6C7.42157 6 6.75 6.67157 6.75 7.5C6.75 8.32843 7.42157 9 8.25 9Z"
      :fill="fillInner"
      class="c-roodie__eye-left"
    />
    <path
      d="M15.75 9C16.5784 9 17.25 8.32843 17.25 7.5C17.25 6.67157 16.5784 6 15.75 6C14.9216 6 14.25 6.67157 14.25 7.5C14.25 8.32843 14.9216 9 15.75 9Z"
      :fill="fillInner"
      class="c-roodie__eye-right"
    />
    <path
      d="M17.25 11.25H6.75C6.33577 11.25 6 11.5858 6 12C6 15.3137 8.68631 18 12 18C15.3137 18 18 15.3137 18 12C18 11.5858 17.6642 11.25 17.25 11.25Z"
      :fill="fillInner"
      class="c-roodie__mouth"
    >
      <animate
        class="animation-to-happy"
        begin="indefinite"
        fill="freeze"
        attributeName="d"
        dur="500ms"
        to="M17.25 11.25H6.75C6.33577 11.25 6 11.5858 6 12C6 15.3137 8.68631 18 12 18C15.3137 18 18 15.3137 18 12C18 11.5858 17.6642 11.25 17.25 11.25Z"
      />
      <animate
        class="animation-to-meh"
        begin="indefinite"
        fill="freeze"
        attributeName="d"
        dur="500ms"
        to="M18 13.7099H6C6 13.7099 6.00001 15.0858 6.00001 15.5C6.00001 15.5 8.68632 15.4599 12 15.4599C15.3137 15.4599 18 15.4599 18 15.4599C18 15.0457 18 13.7099 18 13.7099Z"
      />
    </path>
  </svg>
  <!-- <svg
        width="93"
        height="93"
        viewBox="0 0 93 93"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 46.5C0 20.8188 20.8188 0 46.5 0C72.1812 0 93 20.8188 93 46.5C93 72.1812 72.1812 93 46.5 93H0V46.5Z"
            fill="#948FED"
        >
            <animate
                class="animation-to-happy"
                begin="indefinite"
                fill="freeze"
                attributeName="fill"
                dur="500ms"
                to="#948FED"
            />
            <animate
                class="animation-to-blush"
                begin="indefinite"
                fill="freeze"
                attributeName="fill"
                dur="500ms"
                to="#5E58BE"
            />
        </path>
        <path
            d="M31.9688 34.875C35.1789 34.875 37.7812 32.2727 37.7812 29.0625C37.7812 25.8523 35.1789 23.25 31.9688 23.25C28.7586 23.25 26.1562 25.8523 26.1562 29.0625C26.1562 32.2727 28.7586 34.875 31.9688 34.875Z"
            fill="white"
        >
            <animate
                class="animation-to-happy"
                begin="indefinite"
                fill="freeze"
                attributeName="d"
                dur="500ms"
                to="M31.9688 34.875C35.1789 34.875 37.7812 32.2727 37.7812 29.0625C37.7812 25.8523 35.1789 23.25 31.9688 23.25C28.7586 23.25 26.1562 25.8523 26.1562 29.0625C26.1562 32.2727 28.7586 34.875 31.9688 34.875Z"
            />
            <animate
                class="animation-to-blush"
                begin="indefinite"
                fill="freeze"
                attributeName="d"
                dur="500ms"
                to="M39.1177 31.5263C40.3643 31.5062 41.4421 30.4791 40.9766 29.3225C40.7231 28.6923 40.3801 28.086 39.9455 27.5212C37.3852 24.1945 32.6911 25.1969 29.3644 27.7572C27.4667 29.2176 26.5518 31.1284 26.5911 33.1181C26.6147 34.3168 27.9575 34.8361 29.0421 34.3252C33.0455 32.4393 36.0569 31.5757 39.1177 31.5263Z"
            />
        </path>
        <path
            d="M61.0312 34.875C64.2414 34.875 66.8438 32.2727 66.8438 29.0625C66.8438 25.8523 64.2414 23.25 61.0312 23.25C57.8211 23.25 55.2188 25.8523 55.2188 29.0625C55.2188 32.2727 57.8211 34.875 61.0312 34.875Z"
            fill="white"
        >
            <animate
                class="animation-to-happy"
                begin="indefinite"
                fill="freeze"
                attributeName="d"
                dur="500ms"
                to="M61.0312 34.875C64.2414 34.875 66.8438 32.2727 66.8438 29.0625C66.8438 25.8523 64.2414 23.25 61.0312 23.25C57.8211 23.25 55.2188 25.8523 55.2188 29.0625C55.2188 32.2727 57.8211 34.875 61.0312 34.875Z"
            />
            <animate
                class="animation-to-blush"
                begin="indefinite"
                fill="freeze"
                attributeName="d"
                dur="500ms"
                to="M77.2019 31.0535C78.2745 31.4714 79.5892 31.0066 79.604 29.8557C79.6439 26.7387 76.594 24.3706 73.4672 23.6025C70.4932 22.8719 67.779 24.3491 66.5491 26.8303C65.9609 28.0171 67.1697 29.119 68.494 29.1418C69.7587 29.1637 71.3149 29.3463 73.2008 29.8096C74.7818 30.198 76.1038 30.6257 77.2019 31.0535Z"
            />
        </path>
        <path
            d="M66.8438 43.5938H26.1562C24.5511 43.5938 23.25 44.8948 23.25 46.5C23.25 59.3405 33.6595 69.75 46.5 69.75C59.3405 69.75 69.75 59.3405 69.75 46.5C69.75 44.8948 68.4489 43.5938 66.8438 43.5938Z"
            fill="white"
        >
            <animate
                class="animation-to-happy"
                begin="indefinite"
                fill="freeze"
                attributeName="d"
                dur="500ms"
                to="M66.8438 43.5938H26.1562C24.5511 43.5938 23.25 44.8948 23.25 46.5C23.25 59.3405 33.6595 69.75 46.5 69.75C59.3405 69.75 69.75 59.3405 69.75 46.5C69.75 44.8948 68.4489 43.5938 66.8438 43.5938Z"
            />
            <animate
                class="animation-to-blush"
                begin="indefinite"
                fill="freeze"
                attributeName="d"
                dur="500ms"
                to="M55.1787 47.2066C49.9254 47.3551 47.3597 41.3741 46.7342 38.1378C46.5892 37.3876 47.0129 36.6817 47.7322 36.4241C49.0886 35.9384 51.6176 35.2406 55.1787 35.1237C58.731 35.0071 61.1072 35.5722 62.3586 35.9947C63.0284 36.2208 63.4323 36.8583 63.3729 37.5628C63.0961 40.847 61.3368 47.0325 55.1787 47.2066Z"
            />
        </path>
    </svg> -->
  <!-- <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="276.333px"
        height="276.333px"
        viewBox="0 0 276.333 276.333"
        enable-background="new 0 0 276.333 276.333"
        xml:space="preserve"
        class="c-roodie"
    >
        <g id="Layer_1_copy">
            <g>
                <g>
                    <circle
                        fill="#928DC4"
                        cx="138.167"
                        cy="138.167"
                        r="138.167"
                    />
                    <rect
                        y="138.167"
                        fill="#928DC4"
                        width="138.167"
                        height="138.166"
                    />
                </g>
            </g>
        </g>
        <g id="Layer_3">
            <circle fill="#FFFFFF" cx="94.667" cy="87" r="17.667" />
            <circle fill="#FFFFFF" cx="180.667" cy="87" r="17.667" />
            <path
                fill="#FFFFFF"
                d="M207.667,145.056c-0.67,4.44-1.541,6.822-2.485,9.388c0,0-14.181,52.807-66.848,52.807
		c-51.833,0-66.849-52.807-66.849-52.807C70.45,151.1,70,147.016,70,144.529v-3.27c0-3.198,1.833-8.592,6.484-8.592h124.697
		c5.486,0,6.485,5.549,6.485,8.592V145.056z"
            >
                <animate
                    class="animation-to-meh"
                    begin="indefinite"
                    fill="freeze"
                    attributeName="d"
                    dur="500ms"
                    to="M207.667,165.151c0,6.344-0.083,8.375-0.083,11.484c0,0-33.874,0-69.25,0c-35.375,0-69.333,0-69.333,0
		c0-4.154,0-5.141,0-11.484l0,0c0-6.344,0-7.932,0-11.484h138.75C207.75,157.011,207.667,158.807,207.667,165.151L207.667,165.151z"
                />
            </path>
        </g>
    </svg> -->
</template>

<script>
export default {
  props: {
    expression: {
      type: String,
      required: false,
      default: "happy",
    },
    fillOuter: {
      type: String,
      required: false,
      default: "#948FED",
    },
    fillInner: {
      type: String,
      required: false,
      default: "white",
    },
    size: {
      type: Number,
      required: false,
      default: 30,
    },
  },
  watch: {
    expression(newVal) {
      this.changeExpression(newVal);
    },
  },
  methods: {
    changeExpression(expression) {
      for (const element of this.$refs.roodie.getElementsByClassName(
        "animation-to-" + expression
      )) {
        element.beginElement();
      }
    },
  },
  mounted() {
    this.changeExpression(this.expression);
  },
};
</script>

<style lang="scss" scoped>
.c-roodie path {
  // transition: 1s;
}

.-neutral .c-roodie {
  &__eye-left {
    d: path(
      "M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z"
    );
  }
  &__eye-right {
    d: path(
      "M16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z"
    );
  }
  &__mouth {
    d: path(
      "M17.25 13.7099H6.75C6.33577 13.7099 6 14.0457 6 14.4599C6 17.7736 8.68631 15.4599 12 15.4599C15.3137 15.4599 18 17.7736 18 14.4599C18 14.0457 17.6642 13.7099 17.25 13.7099Z"
    );
  }
}
</style>
